import { render, staticRenderFns } from "./CertificateTable.vue?vue&type=template&id=6c8b3928&"
import script from "./CertificateTable.vue?vue&type=script&lang=js&"
export * from "./CertificateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports